// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__Zy0X9","col":"Table_col__WhVDo","fulfillmentStatus":"Table_fulfillmentStatus__3tPD5","emailCol":"Table_emailCol__mjA-Y"};